// `amount` do plano é string no backend ("149.90" ou "149,90"); aceita ambos.
export const parseAmount = (value) => {
  if (value === null || value === undefined || value === "") return 0;
  if (typeof value === "number") return value;
  const raw = String(value).replace(/[^\d,.-]/g, "");
  const normalized = raw.includes(",") ? raw.replace(/\./g, "").replace(",", ".") : raw;
  const n = parseFloat(normalized);
  return Number.isFinite(n) ? n : 0;
};

export const formatBRL = (value) =>
  value.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

// Preço anual formatado, ou null quando o plano não tem valor anual.
export function yearlyLabel(plan) {
  const n = parseAmount(plan && plan.amountYearly);
  return n > 0 ? formatBRL(n) : null;
}

// Preço mensal formatado, ou null quando o plano é só anual (amount vazio/0).
export function monthlyLabel(plan) {
  const n = parseAmount(plan && plan.amount);
  return n > 0 ? formatBRL(n) : null;
}

// Só os períodos que têm valor: plano só anual não mostra "R$ 0,00 / mês"
// nem "R$ / mês", e vice-versa. Cada item: { period, label }.
export function precosExibiveis(plan) {
  return [
    { period: "MENSAL", label: monthlyLabel(plan) },
    { period: "ANUAL", label: yearlyLabel(plan) },
  ].filter((p) => p.label);
}

// Texto digitado ("4.999,00") -> "4999.00"; vazio/inválido -> null
// (Postgres recusa "" em DECIMAL).
export function normalizeAmountInput(value) {
  if (value === null || value === undefined || String(value).trim() === "") return null;
  if (!/\d/.test(String(value))) return null;
  return parseAmount(value).toFixed(2);
}
